<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-container fluid>
      <!-- <div class="addingItemComponentForm"> -->
      <v-form ref="form1" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Ulaz"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="date = parseDate(dateFormatted)"
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 pa-2>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="0"
              :return-value.sync="time"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="time"
                label=""
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
              ></v-text-field>
              <v-time-picker
                v-model="time"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu1.save(time)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false"
                  >Cancel</v-btn
                >
                <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
              </v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs5 pa-2>
            <v-autocomplete
              v-model="give_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Predao"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit_form"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2 pa-2> </v-flex>
          <v-flex xs5 pa-2>
            <v-autocomplete
              v-model="receive_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Primio"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit_form"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <v-text-field
              v-model="opis"
              label="Opis"
              :disabled="!edit_form"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <!-- <v-flex xs4 pa-2>
            <v-btn @click.stop="otvoriModal" class="AppButtonFilled"
              >Dodaj flaširanje</v-btn
            >
          </v-flex> -->
          <v-flex xs12 pa-2 style="text-align: center">
            <!-- <v-btn @click.stop="otvoriModal" class="AppButtonFilled"
              >Dodaj artikal</v-btn
            >
            <button
                id='closeModalBtn'
                @click.stop="otvoriModal"
                class="v-btn v-btn--flat white"
            >
              <v-icon>close</v-icon>
            </button> -->

            <v-btn
              id="HistoryButton"
              @click="otvoriModal"
              v-if="edit_form && !executed_document"
            >
              <p>
                <v-icon>close</v-icon>
              </p> </v-btn
            ><!-- /#HistoryButton -->
          </v-flex>
        </v-layout>

        <v-layout column>
          <v-flex style="overflow: auto">
            <v-data-table
              :headers="headers_modal"
              :items="items_modal_pom"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props_modal">
                <td>
                  {{ props_modal.item.wine.label }} -
                  {{ props_modal.item.wine.year }}
                </td>
                <!-- <td>
                  {{ formatDateTime(props_modal.item.bottling.date) }}</td> -->
                <td>
                  {{ props_modal.item.bottling.lot }}
                </td>
                <!-- <td>
                  {{ props_modal.item.bottling.tank }}</td> -->
                <td>{{ props_modal.item.bottling.bottleVolumeInLiters }}l</td>
                <td>
                  {{ props_modal.item.quantity }}
                </td>
                <td
                  class="DataTable__ButtonHolder"
                  style="text-align: center; padding-left: 0px !important"
                >
                  <img
                    v-if="edit_form"
                    class="DataTable__Button"
                    title="Izmena"
                    src="../assets/icons/zatabele/ico-edit2.svg"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item)"
                  />
                  <img
                    v-else
                    class="DataTable__Button"
                    title="Pregled"
                    src="../assets/icons/zatabele/ico-view.png"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item)"
                  />
                  <img
                    class="DataTable__Button"
                    title="Brisanje"
                    src="../assets/icons/zatabele/ico-delete2.svg"
                    alt="delete-item"
                    @click="deleteItemModal(props_modal.item)"
                    v-if="edit_form && !executed_document"
                  />
                </td>
              </template>
              <template slot="no-data">
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex
            xs12
            style="text-align: right; margin-bottom: 0px; padding-top: 15px"
          >
            <v-btn
              :disabled="!valid"
              @click="submit"
              class="AppButtonFilled"
              v-if="edit_form"
              >Sačuvaj</v-btn
            >
            <v-btn
              id="Odustani_dugme"
              @click="clear"
              class="AppButtonOutlined"
              v-if="edit_form"
              >odustani</v-btn
            >
          </v-flex>
        </v-layout>
      </v-form>
      <v-dialog
        v-model="dialogNote"
        scrollable
        content-class="ModalInModalMaliPrijemVina"
      >
        <v-container>
          <div class="DataTable" style="width: 450px !important">
            <v-form ref="form_modal" v-model="validModal" lazy-validation>
              <a
                class="closeModalInModalBtn"
                @click.prevent="closeModalInModal"
              >
                <v-icon>close</v-icon>
              </a>
              <!-- /.closeModalBtn -->
              <v-layout row wrap>
                <v-flex xs12 pa-2>
                  <v-autocomplete
                    v-model="wine_to_select"
                    :items="wine_to_items"
                    :item-text="getFieldTextWine"
                    item-value="id"
                    label="Vino"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    v-on:change="changeWine"
                    :disabled="!edit_form"
                    v-if="this.load !== 100"
                  ></v-autocomplete>
                  <v-text-field
                    v-model="pomocni_text_vino"
                    label="Vino"
                    persistent-hint
                    return-object
                    disabled
                    v-else
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <!-- item-value="bottlingId" -->
                <v-flex xs7 pa-2 v-if="this.load !== 100">
                  <v-autocomplete
                    v-model="bottling_select"
                    :items="bottling_items"
                    :item-text="getFieldTextBottling"
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    label="Lot - Ne primljenih boca"
                    required
                    persistent-hint
                    return-object
                    :disabled="!edit_form"
                    v-on:change="changeLot"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs7 pa-2 v-else>
                  <v-text-field
                    v-model="pomocni_text"
                    label="Lot - Ne primljenih boca"
                    persistent-hint
                    return-object
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs2
                  pa-2
                  v-if="edit_form"
                  style="margin-top: 15px; padding-left: 18px !important"
                >
                  <v-btn id="HistoryButtonNew" @click="prebaciBrojFlasa">
                    <p>
                      <v-icon>transit_enterexit</v-icon>
                    </p>
                  </v-btn>
                </v-flex>
                <v-flex xs2 pa-2 v-else> </v-flex>
                <v-flex xs3 pa-2>
                  <v-text-field
                    v-model="quantity"
                    label="Broj boca"
                    type="number"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    :disabled="!edit_form"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs12
                  style="
                    text-align: right;
                    margin-bottom: 0px;
                    padding-top: 15px;
                  "
                >
                  <v-btn
                    :disabled="!validModal"
                    @click="submit_modal"
                    class="AppButtonFilled"
                    v-if="edit_form"
                    >Sačuvaj</v-btn
                  >
                  <v-btn
                    @click="clear_modal"
                    class="AppButtonOutlined"
                    v-if="edit_form"
                    >odustani</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <!-- /.addingToTank -->
        </v-container>
      </v-dialog>
      <TokenComponent ref="frmtoken" />
    </v-container>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "AddingItem",
  components: {
    TokenComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    menu: "",
    menu1: "",
    time: "",
    date: null,
    valid: true,
    validModal: true,
    dateFormatted: null,
    naziv: "",
    ID: 0,
    type: "input",
    input: true,
    give_id: 0,
    receive_id: 0,
    opis: "",
    employee_to_items: [],
    wine_to_items: [],
    wine_to_select: undefined,
    give_to_select: 0,
    receive_to_select: 0,
    dialogNote: false,
    index_izmene: -1,
    izmena_modal: true,
    quantity: undefined,
    bottling_select: "",
    bottling_items: [],
    items_modal: [],
    items_modal_pom: [],
    headers_modal: [
      { text: "Vino", value: "wine.label", align: "center" },
      // { text: "Flasirano", value: "bottling.date" },
      { text: "Lot", value: "bottling.lot", align: "left" },
      // { text: "Tank", value: "bottling.tank" },
      { text: "Boca", value: "bottling.bottleVolumeInLiters", align: "left" },
      {
        text: "Broj boca",
        value: "quantity",
        align: "left",
        style: "width: 15%",
      },
      // { text: "JM", value: "width" },
      { text: "Funkcije", value: "funkcije", align: "center", sortable: false },
    ],
    warehouseID: 0,
    warehouseType: "",
    load: 0,
    edit_form: true,
    executed_document: false,
    number: "",
    pomocni_text: "",
    pomocni_text_vino: "",
    modal_lot: "",
    modal_zapremina: 0,
    itemId: 0,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    wait: function (ms) {
      var start = Date.now(),
        now = start;
      while (now - start < ms) {
        now = Date.now();
      }
    },
    getAllEmployees() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/employee/all/basic",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.employee_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/employee/all/basic",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.employee_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllBottling(a) {
      let _this = this;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/operation/unreceived_bottling/" +
            a,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          _this.bottling_items = response.data;

          if (_this.bottling_items.length !== 0) {
            if (_this.modal_lot !== "" && _this.modal_lot !== null) {
              let pronadjiObj;

              if (_this.modal_lot !== "")
                pronadjiObj = response.data.filter(function (item1) {
                  return (
                    item1.lot === _this.modal_lot &&
                    item1.bottleVolumeInLiters === _this.modal_zapremina
                  );
                });
              else
                pronadjiObj = response.data.filter(function (item1) {
                  return item1.bottleVolumeInLiters === _this.modal_zapremina;
                });

              if (pronadjiObj.length > 0) {
                if (_this.ID > 0 && _this.executed_document)
                  pronadjiObj[0].bottlesUnreceived =
                    pronadjiObj[0].bottlesUnreceived + _this.quantity;

                _this.bottling_select = pronadjiObj[0];

                _this.pomocni_text =
                  _this.modal_lot +
                  " - " +
                  _this.bottling_select.bottlesUnreceived +
                  " boca";
              } else {
                let pomObj = {
                  bottledNumber: 0,
                  bottlesUnreceived: _this.quantity,
                  lot: _this.modal_lot,
                  bottleVolumeInLiters: _this.modal_zapremina,
                  bottlingId: null,
                };

                _this.bottling_items.push(pomObj);
                _this.bottling_select = pomObj;
              }
            } else if (_this.modal_lot === null || _this.modal_lot === 0) {
              let pronadjiObj = response.data.filter(function (item1) {
                return item1.bottleVolumeInLiters === _this.modal_zapremina;
              });

              _this.bottling_select = pronadjiObj[0];

              _this.pomocni_text =
                " - " + _this.bottling_select.bottlesUnreceived + " boca"; // +
            } else if (response.data.length === 1) {
              _this.bottling_select = response.data[0];
              _this.quantity = response.data[0].bottlesUnreceived;
            }
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/operation/unreceived_bottling/" +
                        a,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      _this.bottling_items = response.data;

                      if (_this.bottling_items.length !== 0) {
                        if (
                          _this.modal_lot !== "" &&
                          _this.modal_lot !== null
                        ) {
                          let pronadjiObj;

                          if (_this.modal_lot !== "")
                            pronadjiObj = response.data.filter(function (
                              item1
                            ) {
                              return (
                                item1.lot === _this.modal_lot &&
                                item1.bottleVolumeInLiters ===
                                  _this.modal_zapremina
                              );
                            });
                          else
                            pronadjiObj = response.data.filter(function (
                              item1
                            ) {
                              return (
                                item1.bottleVolumeInLiters ===
                                _this.modal_zapremina
                              );
                            });

                          if (pronadjiObj.length > 0) {
                            let ind = response.data.findIndex(
                              (x) =>
                                x.lot === _this.modal_lot &&
                                x.bottleVolumeInLiters === _this.modal_zapremina
                            );

                            pronadjiObj[0].bottlesUnreceived =
                              pronadjiObj[0].bottlesUnreceived + _this.quantity;

                            _this.bottling_select = pronadjiObj[0];

                            _this.pomocni_text =
                              _this.modal_lot +
                              " - " +
                              _this.bottling_select.bottlesUnreceived +
                              " boca";
                          } else {
                            let pomObj = {
                              bottledNumber: 0,
                              bottlesUnreceived: _this.quantity,
                              lot: _this.modal_lot,
                              bottleVolumeInLiters: _this.modal_zapremina,
                              bottlingId: null,
                            };

                            _this.bottling_items.push(pomObj);
                            _this.bottling_select = pomObj;
                          }
                        } else if (
                          _this.modal_lot === null ||
                          _this.modal_lot === 0
                        ) {
                          let pronadjiObj = response.data.filter(function (
                            item1
                          ) {
                            return (
                              item1.bottleVolumeInLiters ===
                              _this.modal_zapremina
                            );
                          });

                          _this.bottling_select = pronadjiObj[0];

                          _this.pomocni_text =
                            " - " +
                            _this.bottling_select.bottlesUnreceived +
                            " boca"; // +
                        } else if (response.data.length === 1) {
                          _this.bottling_select = response.data[0];
                          _this.quantity = response.data[0].bottlesUnreceived;
                        }
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldText(item) {
      return `${item.firstName} ${item.lastName}`;
    },
    getFieldTextWine(item) {
      return `${item.label} ${item.year}`;
    },
    getFieldTextBottling(item) {
      // return `${item.lot} - ${item.bottlesUnreceived} x ${item.bottleVolumeInLiters}l`;
      return `${item.lot} - ${item.bottlesUnreceived} boca`;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    getAllWine() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/unreceived_wines",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.wine_to_items = response.data;

          if (response.data.length === 1)
            this.wine_to_select = response.data[0];
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/unreceived_wines",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wine_to_items = response.data;

                      if (response.data.length === 1)
                        this.wine_to_select = response.data[0];
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeLot(a) {
      if (this.load < 2) this.quantity = undefined;
    },
    changeWine(a) {
      if (typeof a !== "undefined") {
        this.load = this.load + 1;

        if (a.id === undefined) {
          if (a !== undefined) {
            // this.PreostaloUTanku(a);

            this.getAllBottling(a);

            // if (this.load > 1) this.aditiv_select = undefined;
          }
        } else {
          this.getAllBottling(a.id);

          // if (this.load > 1) this.aditiv_select = undefined;
        }
      }
    },
    otvoriModal() {
      this.dialogNote = true;
      this.getAllWine();

      this.clear_modal();
    },
    prebaciBrojFlasa() {
      if (this.bottling_select !== undefined)
        this.quantity = this.bottling_select.bottlesUnreceived;
      else alert("Niste izabrali lot.");
    },
    closeModalInModal() {
      this.dialogNote = false;
    },
    submit_modal() {
      if (this.$refs.form_modal.validate()) {
        

        if (
          Number(this.bottling_select.bottlesUnreceived) >=
          Number(this.quantity)
        ) {
          var complexPouringAdditiv;

          let pronadjiObjNovi;
          

          pronadjiObjNovi = this.items_modal_pom.findIndex(
            (item1) =>
              item1.wine.id === this.wine_to_select.id &&
              item1.bottling.lot === this.bottling_select.lot
          );

          if (pronadjiObjNovi !== -1 && this.index_izmene === -1)
            alert("Izabrano vino i lot već se nalaze u listi.");
          else if (
            this.index_izmene !== -1 &&
            this.index_izmene !== pronadjiObjNovi &&
            pronadjiObjNovi !== -1
          )
            alert("Izabrano vino i lot već se nalaze u listi.");
          else {
            var pom_artikal;

            if (
              typeof this.wine_to_select !== "undefined" &&
              this.wine_to_select !== ""
            ) {
              if (typeof this.wine_to_select.id === "undefined")
                pom_artikal = this.wine_to_select;
              else pom_artikal = this.wine_to_select.id;
            }

            let pomLot = this.bottling_select.lot;
            let bottlingIdLok = this.bottling_select.bottlingId;

            if (this.itemId !== 0 && this.itemId !== undefined) {
              complexPouringAdditiv = {
                id: this.itemId,
                articleId: pom_artikal,
                lot: pomLot,
                quantity: Number(this.quantity),
                bottling: {
                  id: bottlingIdLok,
                },
              };

              var complexPouringAdditivPom;
              complexPouringAdditivPom = {
                id: this.itemId,
                wine: this.wine_to_select,
                bottling: this.bottling_select,
                quantity: Number(this.quantity),
              };
            } else {
              complexPouringAdditiv = {
                articleId: pom_artikal,
                lot: pomLot,
                quantity: Number(this.quantity),
                bottling: {
                  id: bottlingIdLok,
                },
              };

              var complexPouringAdditivPom;
              complexPouringAdditivPom = {
                wine: this.wine_to_select,
                bottling: this.bottling_select,
                quantity: Number(this.quantity),
              };
            }

            if (this.ID !== 0)
              if (this.index_izmene !== -1) {
                // ovde treba da ide poziv nove procedure za izmenu
                this.edit_modal(complexPouringAdditiv, "INPUT");
              } else {
                // ovde treba da ide poziv nove procedure za unos stavke
                this.add_modal(complexPouringAdditiv, "INPUT");
              }
            else {
              if (this.index_izmene !== -1) {
                this.items_modal.splice(this.index_izmene, 1);
                this.items_modal_pom.splice(this.index_izmene, 1);
              }

              this.items_modal.push(complexPouringAdditiv);
              this.items_modal_pom.push(complexPouringAdditivPom);

              this.clear_modal();
            }
          }
        } else alert("Izabrali ste veću količinu od raspoložive.");
      }
    },
    vrati_objekat(newObject, type) {
      var pomArray = [];
      pomArray.push(newObject);

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;

      let opis = "";
      if (this.opis !== undefined && this.opis !== null) opis = this.opis;

      if (this.ID !== 0)
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: "INPUT",
          give: complexObjectGive,
          receive: complexObjectReceive,
          input: true,
          description: opis,
          warehouseInputOutputItems: pomArray,
        };
      else
        complexInput = {
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: "INPUT",
          give: complexObjectGive,
          receive: complexObjectReceive,
          input: true,
          description: opis,
          warehouseInputOutputItems: pomArray,
        };
      return complexInput;
    },
    edit_modal(locObject, type) {
      let complexInput = this.vrati_objekat(locObject, type);
      let url;

      if (!this.executed_document) url = "/warehouse_input_output_item/update";
      else url = "/warehouse_input_output/update_executed";

      this.$http
        .put(this.globalServiceLocation + this.globalPort + url, complexInput, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation + this.globalPort + url,
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    add_modal(locObject, type) {
      let complexInput = this.vrati_objekat(locObject, type);

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output_item/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output_item/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    clear_modal() {
      this.load = 0;
      this.index_izmene = -1;

      this.$refs.form_modal.reset();

      this.izmena_modal = false;
      this.bottling_items = [];

      this.itemId = 0;

      this.wine_to_select = undefined;

      this.modal_lot = "";
      this.pomocni_text_vino = "";
      this.modal_zapremina = 0;
    },
    clearInit() {
      this.load = 0;
      this.setTime();
      this.setDate();

      this.$refs.form.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];

      // document.getElementById("naslov").innerText = "Ulaz";
    },
    clear() {
      this.load = 0;

      this.setTime();
      this.setDate();

      this.$refs.form.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];

      document.getElementById("naslov").innerText = "Prijem";
    },
    editItemModal(item) {
      this.load = 100;

      if (typeof item.id !== undefined)
        if (item.id !== null) this.itemId = item.id;

      this.modal_lot = item.bottling.lot;
      this.pomocni_text_vino = item.wine.label + " " + item.wine.year;
      this.modal_zapremina = item.bottling.bottleVolumeInLiters;

      let pronadjiObjNovi;

      if (typeof item.wine !== "undefined")
        pronadjiObjNovi = this.wine_to_items.find(
          (item1) => item1.id === item.wine.id
        );

      this.wine_to_select = pronadjiObjNovi;

      this.index_izmene = this.items_modal_pom.indexOf(item);

      this.dialogNote = true;

      if (pronadjiObjNovi !== undefined) this.changeWine(pronadjiObjNovi);
      else {
        this.bottling_select = item.bottling;
        this.bottling_select.bottlesUnreceived = item.quantity;

        

        this.pomocni_text = item.bottling.lot + " - " + item.quantity + " boca";
      }

      this.quantity = item.quantity;
    },
    deleteItemModal(item) {
      if (item.id !== undefined) {
        let url = "/warehouse_input_output_item/delete/" + item.id;

        this.$http
          .delete(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            // // // console.log(response);
            alert("Stavka je uspešno obrisana.");
            this.getAllItem(this.ID);
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .delete(
                        this.globalServiceLocation + this.globalPort + url,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // // console.log(response);
                        alert("Stavka je uspešno obrisana.");
                        this.getAllItem(this.ID);
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      } else {
        const index = this.items_modal_pom.indexOf(item);
        this.items_modal_pom.splice(index, 1);

        this.items_modal.splice(index, 1);
      }
    },
    newSifarnik() {
      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;
      complexInput = {
        warehouse: complexObjectWareHouse,
        date: this.date + "T" + this.time,
        type: "INPUT",
        give: complexObjectGive,
        receive: complexObjectReceive,
        input: true,
        description: this.opis,
        warehouseInputOutputItems: this.items_modal,
      };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          let naslov = document.getElementById("naslov").innerText;
          document.getElementById("naslov").innerText =
            naslov + " " + response.data.documentNumber;

          setTimeout(() => {
            this.wait(500);
            if (this.warehouseType === "bottled_wine")
              poruka =
                "Uspešno je kreiran dokument broj " +
                response.data.documentNumber +
                ". Da li želite da izvršite prijem vina na stanje magacina?";
            else
              poruka =
                "Uspešno je kreiran dokument broj " +
                response.data.documentNumber +
                ". Da li želite da izvršite prijem materijala na stanje magacina?";

            confirm(poruka) && this.prijemDokumenta(response.data.id);

            this.clear();
          }, 10);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      let naslov = document.getElementById("naslov").innerText;
                      document.getElementById("naslov").innerText =
                        naslov + " " + response.data.documentNumber;

                      setTimeout(() => {
                        this.wait(500);
                        if (this.warehouseType === "bottled_wine")
                          poruka =
                            "Uspešno je kreiran dokument broj " +
                            response.data.documentNumber +
                            ". Da li želite da izvršite prijem vina na stanje magacina?";
                        else
                          poruka =
                            "Uspešno je kreiran dokument broj " +
                            response.data.documentNumber +
                            ". Da li želite da izvršite prijem materijala na stanje magacina?";

                        confirm(poruka) &&
                          this.prijemDokumenta(response.data.id);

                        this.clear();
                      }, 10);
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    prijemDokumenta(id) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/execute/" +
            id,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokument je uspešno izvršen.");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/execute/" +
                        id,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Dokument je uspešno izvršen.");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllItem(id) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.ID = response.data.id;
          this.give_to_select = response.data.give;
          this.receive_to_select = response.data.receive;
          this.opis = response.data.description;
          this.date = response.data.date.split("T")[0];
          this.time = this.formatTime(response.data.date.split("T")[1]);

          this.items_modal = [];
          this.items_modal_pom = [];

          let complexPouringAdditiv;
          let complexPouringAdditivPom;

          let _this = this;

          response.data.warehouseInputOutputItems.forEach(function (element) {
            // complexPouringAdditiv = {
            //   bottling: {
            //     id: element.bottlingId,
            //   },
            //   quantity: Number(element.quantity),
            // };

            complexPouringAdditiv = {
              id: element.id,
              articleId: element.articleId,
              lot: element.lot,
              quantity: Number(element.quantity),
              bottling: {
                id: element.bottlingId,
              },
            };

            complexPouringAdditivPom = {
              id: element.id,
              wine: {
                id: element.articleId,
                label: element.wineName,
                year: element.wineYear,
              },
              bottling: {
                lot: element.lot,
                bottleVolumeInLiters: element.bottleVolumeInLitres, //,

                bottlingId: element.bottlingId,
                // bottledNumber: 10,
                // bottlesUnreceived: 0,
                // date: element.bottlingOrProductionDate,
                // tank: element.tank,
                // tankPhaseWineId: element.tankPhaseWineId,
              },
              quantity: Number(element.quantity),
            };

            _this.items_modal.push(complexPouringAdditiv);
            _this.items_modal_pom.push(complexPouringAdditivPom);
          });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.ID = response.data.id;
                      this.give_to_select = response.data.give;
                      this.receive_to_select = response.data.receive;
                      this.opis = response.data.description;
                      this.date = response.data.date.split("T")[0];
                      this.time = this.formatTime(
                        response.data.date.split("T")[1]
                      );

                      this.items_modal = [];
                      this.items_modal_pom = [];

                      let complexPouringAdditiv;
                      let complexPouringAdditivPom;

                      let _this = this;

                      response.data.warehouseInputOutputItems.forEach(function (
                        element
                      ) {
                        // complexPouringAdditiv = {
                        //   bottling: {
                        //     id: element.bottlingId,
                        //   },
                        //   quantity: Number(element.quantity),
                        // };

                        complexPouringAdditiv = {
                          id: element.id,
                          articleId: element.articleId,
                          lot: element.lot,
                          quantity: Number(element.quantity),
                          bottling: {
                            id: element.bottlingId,
                          },
                        };

                        complexPouringAdditivPom = {
                          id: element.id,
                          wine: {
                            id: element.articleId,
                            label: element.wineName,
                            year: element.wineYear,
                          },
                          bottling: {
                            lot: element.lot,
                            bottleVolumeInLiters: element.bottleVolumeInLitres,

                            // bottlingId: element.bottlingId,
                            // bottledNumber: 10,
                            // bottlesUnreceived: 0,
                            // date: element.bottlingOrProductionDate,
                            // tank: element.tank,
                            // tankPhaseWineId: element.tankPhaseWineId
                          },
                          quantity: Number(element.quantity),
                        };

                        _this.items_modal.push(complexPouringAdditiv);
                        _this.items_modal_pom.push(complexPouringAdditivPom);
                      });
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },

    changeSifarnik() {
      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;
      complexInput = {
        id: this.ID,
        number: this.number,
        warehouse: complexObjectWareHouse,
        date: this.date + "T" + this.time,
        type: "INPUT",
        give: complexObjectGive,
        receive: complexObjectReceive,
        input: true,
        description: this.opis,
        warehouseInputOutputItems: this.items_modal,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/update",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          // if (this.warehouseType === "bottled_wine")
          //   poruka =
          //     "Uspešno je izmenjen dokument broj " +
          //     this.number +
          //     ". Da li želite da izvršite prijem vina na stanje magacina?";
          // else
          //   poruka =
          //     "Uspešno je izmenjen dokument broj " +
          //     this.number +
          //     ". Da li želite da izvršite prijem materijala na stanje magacina?";

          if (this.warehouseType === "bottled_wine")
            poruka =
              "Da li želite da izvršite početno stanje vina na stanje magacina?";
          else
            poruka =
              "Da li želite da izvršite početno stanje materijala na stanje magacina?";

          confirm(poruka) && this.prijemDokumenta(this.ID);

          this.clear();
        })
        .catch((e) => {
          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/update",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      // if (this.warehouseType === "bottled_wine")
                      //   poruka =
                      //     "Uspešno je izmenjen dokument broj " +
                      //     this.number +
                      //     ". Da li želite da izvršite prijem vina na stanje magacina?";
                      // else
                      //   poruka =
                      //     "Uspešno je izmenjen dokument broj " +
                      //     this.number +
                      //     ". Da li želite da izvršite prijem materijala na stanje magacina?";

                      if (this.warehouseType === "bottled_wine")
                        poruka =
                          "Da li želite da izvršite početno stanje vina na stanje magacina?";
                      else
                        poruka =
                          "Da li želite da izvršite početno stanje materijala na stanje magacina?";

                      // if (confirm(poruka))
                      //   this.prijemDokumenta(this.ID);
                      // else
                      //   this.dialogNote = false;

                      confirm(poruka) && this.prijemDokumenta(this.ID);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnikExcecuted() {
      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;

      if (this.opis !== undefined && this.opis !== null)
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: "INPUT",
          give: complexObjectGive,
          receive: complexObjectReceive,
          input: true,
          description: this.opis,
        };
      else
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: "INPUT",
          give: complexObjectGive,
          receive: complexObjectReceive,
          input: true,
        };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/update_executed",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          if (this.warehouseType === "bottled_wine")
            poruka = "Uspešno je izmenjen dokument broj " + this.number + ".";
          else
            poruka = "Uspešno je izmenjen dokument broj " + this.number + ".";

          // if (confirm(poruka))
          //   this.prijemDokumenta(this.ID);
          // else
          //   this.dialogNote = false;

          // alert(poruka);

          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/update_executed",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      if (this.warehouseType === "bottled_wine")
                        poruka =
                          "Uspešno je izmenjen dokument broj " +
                          this.number +
                          ".";
                      else
                        poruka =
                          "Uspešno je izmenjen dokument broj " +
                          this.number +
                          ".";

                      // if (confirm(poruka))
                      //   this.prijemDokumenta(this.ID);
                      // else
                      //   this.dialogNote = false;

                      // alert(poruka);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.items_modal.length < 1)
          alert("Niste izabrali ni jednu stavku flaširanja.");
        else {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && this.ID != "0") {
              if (this.executed_document) this.changeSifarnikExcecuted();
              else this.changeSifarnik();
            } else this.newSifarnik();
          }, 1000);
        }
      }
    },
  },
  beforeMount() {
    serverBus.$on("wh_input", (id, tip_magacina, item) => {
      this.warehouseID = id;
      this.warehouseType = tip_magacina;

      if (item !== null) {
        this.load = 1;
        this.getAllWine();

        this.edit_form = item.edit;
        this.executed_document = item.executed;

        this.number = item.number;

        this.getAllItem(item.id);
      }
    });
  },
  mounted() {
    this.clearInit();
    this.getAllEmployees();
  },

  destroyed() {
    serverBus.$off("wh_input");
  },
};
</script>

<style lang="scss" scoped>
@import "./parts/../../assets/sass/parts/modalStyles";

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

#HistoryButtonNew {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 30px;
  height: 30px;
  font-size: 25px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 4px;
      top: -4px;
      transform: rotate(225deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

.v-btn {
  min-width: 0;
}

// .Dialog {
//   max-width: 1200px !important;
// }

.DataTable {
  width: 900px !important;
}

// .v-container{
//   width: 900px !important;
// }

#Odustani_dugme {
  text-align: right !important;
}
</style>
